



































































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import MappingOverridesCreateDialog from '@/components/Products/ProductGeneralLedger/MappingOverridesCreateDialog.vue';
import MappingOverridesEditDialog from '@/components/Products/ProductGeneralLedger/MappingOverridesEditDialog.vue';
import GeneralLedgerMappingOverride from '@/models/Products/ProductGeneralLedgerMapping/GeneralLedgerMappingOverride';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'MappingOverrides', components: { MappingOverridesCreateDialog, MappingOverridesEditDialog } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    headers = [
        { text: this.$t('pageText.products.fields.transactionType'), sortable: false, width: '50%' },
        { text: this.$t('pageText.products.fields.subTransactionType'), sortable: false, width: '50%' },
    ];
    mappingOverridesPage = 1;

    get mappingOverrides() {
        return ProductDetailsModule.generalLedgerMappingOverrides;
    }

    async updateCurrentMappingOverride(generalLedgerMappingOverride: GeneralLedgerMappingOverride) {
        await ProductDetailsModule.updateCurrentGeneralLedgerMappingOverride(generalLedgerMappingOverride);
    }

    get currentMappingOverride() {
        return ProductDetailsModule.currentGeneralLedgerMappingOverride;
    }

    get loading() {
        return ProductDetailsModule.loading;
    }

    get totalMappingOverridesPages() {
        return ProductDetailsModule.totalGeneralLedgerMappingOverridesPages;
    }

    get pageSize() {
        return ProductDetailsModule.pageSize;
    }

}
